import React from "react";
import { useSelectedCareRecipient } from "../../hooks/care_recipient/useSelectedCareRecipient";
import classes from "./ContactsPage.module.scss";
import { useContacts } from "./hooks/useContacts";
import { useAuthUser } from "../../hooks/auth/useAuthUser";
import { RegisterContact } from "./RegisterContact";
import { useBoolean } from "../../hooks/common/useBoolean";
import { orderSuccessToast } from "../../funcs/orderResultToast";
import { ContactList } from "./ContactList";

export function ContactsPage() {

    const careRecipient = useSelectedCareRecipient();

    const { id: userId } = useAuthUser();
    const { contacts, reload } = useContacts(userId.value, careRecipient);

    const [value, on, off, ] = useBoolean(false);

    const onRegisterSuccess = () => {
        off();
        reload();
        orderSuccessToast("連絡先を登録しました");
    };

    return (
        <div className={classes.pageContainer}>
            <div className={classes.container}>
                {value ?
                    <RegisterContact userId={userId.value} careRecipientId={careRecipient?.id.value ?? null} onSubmitSuccess={onRegisterSuccess} onCancel={off}/> : <ContactList contacts={contacts} careRecipient={careRecipient?.id ?? null} openAddPage={on} reloadData={reload}/>
                }
            </div>
        </div>
    );
}

